import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {resolveSkeletonBrickTheme} from '@Components/ai-chat-window/lib/skeleton.library';
import type {EntityCardSkeletonProps} from './entity-card-skeleton.types';
import styles from './entity-card-skeleton.module.scss';

/**
 * Transient placeholder echoing the entity-card shape (a cover thumbnail plus title + meta
 * lines). Every brick shares one theme so the image and text skeletons read as a single
 * surface: grey while loading, colorful (AI gradient) while the agent is generating.
 */
export function EntityCardSkeleton({mode}: EntityCardSkeletonProps): ReactElement {
  const theme = resolveSkeletonBrickTheme(mode);

  return (
    <div className={styles.root}>
      <SkeletonBrick className={styles.media} theme={theme} />
      <div className={styles.text}>
        <SkeletonBrick className={styles.titleLine} height={16} radius={'4px'} theme={theme} />
        <SkeletonBrick className={styles.metaLine} height={14} radius={'4px'} theme={theme} />
      </div>
    </div>
  );
}
